
const Inview = new function () {
	this.init = () => {
		const scroller = document.querySelector('#sn-page') || document.body

		document.querySelectorAll('[data-inview]').forEach(el => {
			ScrollTrigger.create({
				trigger: el,
				scroller,
				start: 'top 75%',
				// end: 'top center',
				// scrub: true,
				toggleClass: { targets: el, className: 'is-inview' },
				once: true, // o true si solo quieres una vez
				// markers: true,
				onEnter: () => {
					el.classList.add('is-inview')
				},
			})
		})

		// Muy importante: forzar refresh
		ScrollTrigger.refresh()
	}
}

export default Inview